// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import type { HeadFC, PageProps } from 'gatsby'
import TitlePage from '../components/home/heroSection/TitlePage'
import { SEO } from '../components/seo'
import Pricing from '../components/home/pricing/Pricing'
import Offerings from '../components/home/offerings/Offerings'
import GaudiAiSection from '../components/home/gaudiAiSection/GaudiAiSection'
import ResourceTemplate from '../components/home/resourceAIandRD/ResourceTemplate'
import Intersticial from '../components/global/intersticialCustom/Intersticial'
import Intersticials from '../components/global/intersticialCustom/Intersticials.types'
import Announcement from '../components/global/announcement/Announcement'
import Announcements from '../components/global/announcement/Announcement.types'
import PageLayout from '../components/global/pageLayout/PageLayout'
import Deployment from '../components/home/deployment/Deployment'

const IndexPage: React.FC<PageProps> = () => {
  return (
    <PageLayout>
      <TitlePage />
      <Announcement {...Announcements.gaudi3xeon6} />
      <Offerings />
      <Deployment />
      <Pricing />
      <GaudiAiSection />
      <ResourceTemplate page="rd" />
      <Intersticial {...Intersticials.bePartOfOurProgram} />
      <ResourceTemplate page="ai" />
      <Intersticial {...Intersticials.getStarted} />
    </PageLayout>
  )
}

export default IndexPage

export const Head: HeadFC = () => (
  <SEO
    title="Intel® Tiber™ AI Cloud - Build and Deploy AI at Scale"
    description="Scale AI workflows! Intel® Tiber™ AI Cloud offers cost-effective GPUs & AI processor infrastructure. Build, deploy & manage AI models with expert support."
  />
)
